import type { StandardCart } from '@/types/ShopFront/CheckoutStandards'
import { getCart } from '../Cart/getCart'
import withExtendWarrantyNormalization from '../Cart/withExtendWarrantyNormalization'
import { getCartFromExtendInterface } from './getCart'

type ExtendWarrantyModalOpener = (p: { sku: string, quantity: number }) =>
Promise<{ success: boolean, newCart: StandardCart | null }>

const rawOpenExtendWarrantyModal: ExtendWarrantyModalOpener = async ({ sku, quantity }) => {
  const cart = await getCartFromExtendInterface()
  return new Promise((resolve) => {
    window.Extend.modal.open({
      referenceId: sku,
      onClose: (plan) => {
        window.ExtendBigCommerce.addPlanToCart({
          sku, plan, quantity, cart,
        }, async (error) => (
          error
            ? resolve({ success: false, newCart: await getCart() })
            : resolve({ success: true, newCart: await getCart() })
        ))
      },
    })
  })
}

export const openExtendWarrantyModal = withExtendWarrantyNormalization(rawOpenExtendWarrantyModal)
export default openExtendWarrantyModal
